module.exports = __webpack_public_path__ + "media/packs/images/flags/SE-b47b4e43d0bdc376549158a1422b98d4.svg";